// @ts-nocheck

import { ISources, SourcesResponseType } from '@/entity/sources/sources.types';

export default class Sources implements ISources {
    id: number;
    name: string;
    color: string;
    clients: any;
    constructor(data: SourcesResponseType) {
      this.id = data.id;
      this.name = data.name;
      this.color = data.color;
      this.clients = data.clients || [];
    }
}
